import { LazyMotion, m } from 'framer-motion';

const loadFeatures = () => import('./features.js').then((res) => res.default);

type Props = {
  children: React.ReactNode;
};

export function MotionLazyContainer({ children }: Props) {
  return (
    <LazyMotion features={loadFeatures}>
      <m.div style={{ height: '100%' }}> {children} </m.div>
    </LazyMotion>
  );
}
